<template>
  <div class="cavani_tm_section" id="ajuda">
    <div class="section_inner">
      <div class="cavani_tm_newss">
        <div class="cavani_tm_title">
          <span>Regulamento Completo</span>
        </div>
        <div class="news_list">
          <a href="/site/documentos/regulamentos/XIMostraCompleto.pdf?v=1.1" target="_blank">Clique para ver o regulamento completo</a>
        </div>
      </div>

      <div class="cavani_tm_newss">
        <div class="cavani_tm_title">
          <span>Ajuda</span>
        </div>
        <div class="news_list">
          <ul>
            <li>
              <div class="list_inner">
                <div class="image">
                  <img :src="'site/ajuda/inscricao.jpg'" alt="" />
                  <div class="main" :data-img-url="'site/ajuda/inscricao.jpg'"></div>
                  <a class="cavani_tm_full_link" href="https://www.loom.com/share/20238dd5563540188efcd21bbc33b1de" target="_blank"></a>
                </div>
                <div class="details">
                  <div class="metabox">
                    <div class="info">
                      <span class="category"><a href="https://www.loom.com/share/20238dd5563540188efcd21bbc33b1de'" target="_blank">Pré-inscrição</a></span>
                      <span class="date">Ajuda</span>
                    </div>
                    <div class="title">
                      <h3><a href="#">Como realizar sua pré-inscrição na Mostra?</a></h3>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="list_inner">
                <div class="image">
                  <img :src="'site/ajuda/alterar_senha.jpg'" alt="" />
                  <div class="main" :data-img-url="'site/ajuda/alterar_senha.jpg'"></div>
                  <a class="cavani_tm_full_link" href="https://www.loom.com/share/8080035fda5c451fa61e9d57fd90776f" target="_blank"></a>
                </div>
                <div class="details">
                  <div class="metabox">
                    <div class="info">
                      <span class="category"><a href="https://www.loom.com/share/8080035fda5c451fa61e9d57fd90776f'" target="_blank">Alterar senha / email</a></span>
                      <span class="date">Ajuda</span>
                    </div>
                    <div class="title">
                      <h3><a href="#">Como alterar a senha?</a></h3>
                    </div>
                  </div>
                </div>
              </div>
            </li>

<!--            <li>-->
<!--              <div class="list_inner">-->
<!--                <div class="image">-->
<!--                  <img :src="'site/ajuda/orientadores.jpg'" alt="" />-->
<!--                  <div class="main" :data-img-url="'site/ajuda/orientadores.jpg'"></div>-->
<!--                  <a class="cavani_tm_full_link" href="https://www.loom.com/share/8080035fda5c451fa61e9d57fd90776f" target="_blank"></a>-->
<!--                </div>-->
<!--                <div class="details">-->
<!--                  <div class="metabox">-->
<!--                    <div class="info">-->
<!--                      <span class="category"><a href="https://www.loom.com/share/8080035fda5c451fa61e9d57fd90776f'" target="_blank">Veja este vídeo explicativo</a></span>-->
<!--                    </div>-->
<!--                    <div class="title">-->
<!--                      <h3><a href="#">Como enviar e corrigir os documentos este ano?</a></h3>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </li>-->

<!--            <li>-->
<!--              <div class="list_inner">-->
<!--                <div class="image">-->
<!--                  <img :src="'site/ajuda/avaliadores.jpg'" alt="" />-->
<!--                  <div class="main" :data-img-url="'site/ajuda/avaliadores.jpg'"></div>-->
<!--                  <a class="cavani_tm_full_link" href="https://www.loom.com/share/8080035fda5c451fa61e9d57fd90776f" target="_blank"></a>-->
<!--                </div>-->
<!--                <div class="details">-->
<!--                  <div class="metabox">-->
<!--                    <div class="info">-->
<!--                      <span class="category"><a href="https://www.loom.com/share/8080035fda5c451fa61e9d57fd90776f'" target="_blank">Como avaliar este ano?</a></span>-->
<!--                    </div>-->
<!--                    <div class="title">-->
<!--                      <h3><a href="#">Como avaliar um projeto este ano?</a></h3>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </li>-->
          </ul>
        </div>
      </div>

      <div class="cavani_tm_newss">
        <div class="cavani_tm_title">
          <span>Downloads</span>
        </div>
        <div class="news_list">
          <ul>
<!--            <li>-->
<!--              <div class="list_inner">-->
<!--                <div class="image">-->
<!--                  <img :src="'site/ajuda/distribuicao_dia_09.jpg'" alt="" />-->
<!--                  <div class="main" :data-img-url="'site/ajuda/distribuicao_dia_09.jpg'"></div>-->
<!--                  <a class="cavani_tm_full_link" :href="route('site.download', ['distribuicao_dia_09'])" target="_blank"></a>-->
<!--                </div>-->
<!--                <div class="details">-->
<!--                  <div class="metabox">-->
<!--                    <div class="info">-->
<!--                      <span class="category">-->
<!--                        <a :href="route('site.download', ['distribuicao_dia_09'])" target="_blank">-->
<!--                          Download-->
<!--                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">-->
<!--                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />-->
<!--                          </svg>-->
<!--                        </a>-->
<!--                      </span>-->
<!--                      <span class="date"></span>-->
<!--                    </div>-->
<!--                    <div class="title">-->
<!--                      <h3><a :href="route('site.download', ['distribuicao_dia_09'])" target="_blank">Faça download aqui <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">-->
<!--                        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />-->
<!--                      </svg></a></h3>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </li>-->

<!--            <li>-->
<!--              <div class="list_inner">-->
<!--                <div class="image">-->
<!--                  <img :src="'site/ajuda/distribuicao_dia_10.jpg'" alt="" />-->
<!--                  <div class="main" :data-img-url="'site/ajuda/distribuicao_dia_10.jpg'"></div>-->
<!--                  <a class="cavani_tm_full_link" :href="route('site.download', ['distribuicao_dia_10'])" target="_blank"></a>-->
<!--                </div>-->
<!--                <div class="details">-->
<!--                  <div class="metabox">-->
<!--                    <div class="info">-->
<!--                      <span class="category">-->
<!--                        <a :href="route('site.download', ['distribuicao_dia_10'])" target="_blank">-->
<!--                          Download-->
<!--                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">-->
<!--                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />-->
<!--                          </svg>-->
<!--                        </a>-->
<!--                      </span>-->
<!--                      <span class="date"></span>-->
<!--                    </div>-->
<!--                    <div class="title">-->
<!--                      <h3><a :href="route('site.download', ['distribuicao_dia_10'])" target="_blank">Faça download aqui <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">-->
<!--                        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />-->
<!--                      </svg></a></h3>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </li>-->

            <li>
              <div class="list_inner">
                <div class="image">
                  <img :src="'site/ajuda/inscricao.jpg'" alt="" />
                  <div class="main" :data-img-url="'site/ajuda/download-resumo.jpg'"></div>
                  <a class="cavani_tm_full_link" :href="route('site.download', ['resumo'])" target="_blank"></a>
                </div>
                <div class="details">
                  <div class="metabox">
                    <div class="info">
                      <span class="category">
                        <a :href="route('site.download', ['resumo'])" target="_blank">
                          Download
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                          </svg>
                        </a>
                      </span>
                      <span class="date">Resumo</span>
                    </div>
                    <div class="title">
                      <h3><a :href="route('site.download', ['resumo'])" target="_blank">Faça download do Resumo modelo <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                      </svg></a></h3>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="list_inner">
                <div class="image">
                  <img :src="'site/ajuda/inscricao.jpg'" alt="" />
                  <div class="main" :data-img-url="'site/ajuda/download-poster.jpg'"></div>
                  <a class="cavani_tm_full_link" :href="route('site.download', ['poster'])" target="_blank"></a>
                </div>
                <div class="details">
                  <div class="metabox">
                    <div class="info">
                      <span class="category">
                        <a :href="route('site.download', ['poster'])" target="_blank">
                          Download
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                          </svg>
                        </a>
                      </span>
                      <span class="date">Pôster</span>
                    </div>
                    <div class="title">
                      <h3><a :href="route('site.download', ['poster'])" target="_blank">Faça download do Pôster modelo <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                      </svg></a></h3>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
